module.exports = __webpack_public_path__ + "img/free.2c34febb.jpg";